export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-like-584ec57fe1295b98dbefb91fc73d77e9.svg";